<template>
  <el-container>
    <div class="fullscreen">
      <el-aside width="auto">
        <el-menu
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          :collapse="isCollapse"
          background-color="#545c64"
          text-color="#fff"
          :unique-opened="true"
          active-text-color="#ffd04b"
          router
        >
          <el-submenu
            index="/users"
            v-show="userInfo.is_admin && userInfo.admin_level === 2"
          >
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span slot="title">用户管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/users/list">用户列表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu
            index="/statement"
            v-show="
              !userInfo.is_admin || (userInfo.is_admin && userInfo.admin_level === 2)
            "
          >
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span slot="title">结算单管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/statement/projects">项目信息</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu v-show="userInfo.is_admin"  index="/verifiers">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span slot="title">项目审核管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/budget/verifiers">预算审核</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/final/verifiers">决算审核</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-menu-item
            index="/cargos"
            v-show="userInfo.is_admin && userInfo.admin_level === 2"
          >
            <i class="el-icon-s-goods"></i>
            <span slot="title">货品资料管理</span>
          </el-menu-item>

          <el-menu-item index="/suppliers">
            <i class="el-icon-s-check"></i>
            <span slot="title">供应商管理</span>
          </el-menu-item>

          <el-menu-item
            index="/receivers"
            v-show="userInfo.is_admin && userInfo.admin_level === 2"
          >
            <i class="el-icon-s-finance"></i>
            <span slot="title">承接单位管理</span>
          </el-menu-item>

          <el-menu-item index="/customers">
            <i class="el-icon-s-custom"></i>
            <span slot="title">客户管理</span>
          </el-menu-item>

          <el-submenu index="/statistic">
            <template slot="title">
              <i class="el-icon-s-marketing"></i>
              <span slot="title">统计信息展示</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/recive/accounts">应收账款明细</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group>
              <el-menu-item index="/payment/accounts">应付账款明细</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>

      <el-main>
        <div class="header">
          <div class="header_left">
            <div class="collapse-btn" @click="isCollapse = !isCollapse">
              <i class="el-icon-s-fold" v-if="!isCollapse"></i>
              <i class="el-icon-s-unfold" v-else></i>
            </div>
          </div>
          <div class="header_operation">
            <div class="operation-user">
              <!-- <span class="title">{{user}}</span> -->
              <el-avatar :src="require('../assets/img/userimg.jpg')"></el-avatar>
            </div>
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <span>{{ userInfo.username }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item divided @click.native="updatePwdBtn()"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item divided @click.native="loginout()"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="main_page">
          <div class="main_page_wrapper">
            <router-view />
          </div>
        </div>
      </el-main>

      <el-dialog
        title="修改个人密码"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <div style="margin-right: 35px">
          <el-form ref="form" :model="form" label-width="120px" :rules="rules">
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="重复密码" prop="repwd">
              <el-input v-model="form.repwd" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="updatePwd">立即修改</el-button>
              <el-button @click="dialogFormVisible = false">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>

<style>
* {
  padding: 0;
  margin: 0;
}
/* 头部样式 */
.el-container {
  width: 100%;
  height: 100%;
}

.el-container .fullscreen {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
}

.el-container .fullscreen .el-aside {
  height: 100%;
}

.el-container .fullscreen .el-main {
  height: 100%;
  position: relative;
  overflow-x: hidden;
  padding: 0px;
}
.el-container .fullscreen .el-aside .el-menu {
  height: 100%;
  border: 0px;
}
.el-container .fullscreen .el-aside .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 270px;
  min-height: 400px;
}
.el-container .fullscreen .el-main .header {
  height: 64px;
  list-style: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
}
.el-container .fullscreen .el-main .header .header_operation {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.el-container .fullscreen .el-main .header .header_left {
  display: flex;
  align-items: center;
}
.el-container .fullscreen .el-main .header .header_operation .el-dropdown {
  margin-left: 10px;
}
.el-container .fullscreen .el-main .header .header_left .collapse-btn {
  margin-right: 40px;
  font-size: 22px;
  color: #666;
  cursor: pointer;
}
.main_page .main_page_wrapper {
  padding: 20px 20px 0px 20px;
}

.custom-dic-explanation {
  font-family: HiraginoSansGB-W3;
  color: #666;
  padding: 18px 18px 23px 33px;
  background-color: #f4f4f4;
  margin-top: 25px;
}

.custom-dic-demo-link {
  color: #0073eb;
  text-decoration: none;
}
.custom-dic-config {
  display: inline-block;
  color: #999;
  margin-left: 15px;
  font-size: 12px;
}
.custom-dic-explanation li {
  margin-bottom: 10px;
}
</style>

<script>
import { getUserInfo } from "../utils/utils.js";
export default {
  name: "Home",
  data() {
    return {
      form: {
        password: "",
        repwd: "",
      },
      dialogFormVisible: false,
      userName: "",
      schedulerObj: {},
      userInfo: {
        is_admin: false,
        user_id: null,
        username: "",
        admin_level: 0,
      },
      progressTimer: null,
      progressStatus: null, // 进度条的状态
      sceneAction: "",
      isCollapse: false,
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度必须大于 6 个字符", trigger: "blur" },
        ],
        repwd: [
          { required: true, message: "请输入重复密码", trigger: "blur" },
          { min: 6, message: "密码长度必须大于 6 个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    updatePwd() {
      let that = this;
      that.$refs["form"].validate((valid) => {
        if (valid) {
          that.$axios
            .put(that.host + "/api/users/password", that.form)
            .then((res) => {
              that.$message.success("修改成功");
              that.dialogFormVisible = false;
            })
            .catch((err) => {
              that.$message.error(err.data.errmsg);
            });
        } else {
          that.$message.warning("参数验证失败");
          return false;
        }
      });
    },
    updatePwdBtn() {
      let that = this;
      that.dialogFormVisible = true;
      that.form = {
        password: "",
        repwd: "",
      };
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    //退出登录
    loginout() {
      this.$confirm("是否确定退出系统", "退出提示", {
        "confirm-button-text": "确定",
        "cancel-button-text": "取消",
      })
        .then(() => {
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("username");
          this.$router.push("/login");
          this.$message.success("退出成功");
        })
        .catch(() => {});
    },
  },
  mounted() {
    // 存储domain_id
    let that = this;
    that.userName = sessionStorage.getItem("username");
    getUserInfo().then((res) => {
      that.userInfo = res;
      if (that.userInfo.is_admin && that.userInfo.admin_level === 1) {
        that.$router.push("/budget/verifiers");
      }
    });
  },
  destroyed() {
    let that = this;
    window.clearTimeout(that.progressStatus);
  },
};
</script>
